import React, { useState } from 'react';
import { useSelectUsersContext } from '../../Services/SelectUsersContext';
import { useGroupsContext } from '../../Services/GroupsContext';
import useNotification from '../../../../Hooks/useNotification.hook';
import EArchiveGroupToolbar from './EArchiveGroupToolbar';
import EArchiveGroupsListCreateModal from '../EArchiveGroupsListWrapper/EArchiveGroupsListCreateModal/EArchiveGroupsListCreateModal';
import { GroupListContent } from '../../Enums/GroupListContent.enum';
import { GroupDetailListContent } from '../../Enums/GroupDetailListContent.enum';

const EArchiveCreateGroupToolbar = () => {
	const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState(false);

	const { userIds, stopSelectingUsers } = useSelectUsersContext();
	const { setCreateGroupMode, setGroupListContent, setGroupDetailListContent } =
		useGroupsContext();
	const { showNotificationAlert } = useNotification();

	const handleOpenCreateGroupModal = () => {
		return userIds.length === 0
			? showNotificationAlert({
					content: 'component.eArchive.groups.createGroupSelectAtLeastOne',
			  })
			: setIsCreateGroupModalOpen(true);
	};

	const handleCancelCreate = () => {
		stopSelectingUsers();
		setCreateGroupMode(undefined);
		setGroupListContent(GroupListContent.GROUPS);
		setGroupDetailListContent(GroupDetailListContent.MEMBERS);
	};

	return (
		<>
			<EArchiveGroupToolbar
				onSubmit={handleOpenCreateGroupModal}
				onCancel={handleCancelCreate}
				submitText={'component.eArchive.groups.createGroup'}
				cancelText={'base.shared.cancel'}
			/>
			{isCreateGroupModalOpen && (
				<EArchiveGroupsListCreateModal
					isOpen
					onClose={() => setIsCreateGroupModalOpen(false)}
				/>
			)}
		</>
	);
};

export default EArchiveCreateGroupToolbar;
